const newlineRegex = /(\\r\\n|\\r|\\n)/g

export const formatNl = (str: string) => {
  return str.split(newlineRegex).map((piece) => (newlineRegex.test(piece) ? '\n' : piece))
}
